<template>
  <div class="app-feature-section container">
    <div data-aos="slide-right" data-aos-duration="10000">
      <img src="../../assets/images/feature-app-image.jpg" />
    </div>
    <div
      class="feature-content"
      data-aos="slide-left"
      data-aos-duration="10000"
    >
      <div>
        <h1>Aprendiendo a programar desde tus raices</h1>
        <p>
          Mediante el uso de un psuedocodigo sencillo que permita al estudiante aprender a programar si la necesidad de conocer una lengua externa.
        </p>
      </div>
      <div class="feature-list">
        <div class="feature-info">
          <div class="icon-background icon-padding">
            <IconComponent name="speed" />
          </div>
          <div>
            <h2 class="red">
              Diseño Amigable
            </h2>
            <p>
              Hace que aprender a programar se más sencillo.
            </p>
          </div>
        </div>
        <div class="feature-info">
          <div class="icon-background icon-padding">
            <IconComponent name="prototyping" />
          </div>
          <div>
            <h2 class="blue">
              Ejercicios Prácticos
            </h2>
            <p>
              Aprende mientras resuelves ejercicios dinámicos
            </p>
          </div>
        </div>
        <div class="feature-info">
          <div class="icon-background icon-padding">
            <IconComponent name="pen" />
          </div>
          <div>
            <h2 class="green">
              Ingresa a un mundo nuevo
            </h2>
            <p>
              La programación es la llave a nuevas oportunidades para aquellos dispuestos a arriesgarse
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconComponent from "./IconComponent";
export default {
  components: {
    IconComponent
  }
};
</script>
